var exports = {
  "kL": "AddFriendSheet.module__container___cUhkT3",
  "XG": "AddFriendSheet.module__scroller___cUhkT3",
  "Qs": "AddFriendSheet.module__content___cUhkT3",
  "Y4": "AddFriendSheet.module__requestsSection___cUhkT3",
  "Ic": "AddFriendSheet.module__requestsGroup___cUhkT3",
  "sg": "AddFriendSheet.module__requestsHeader___cUhkT3",
  "vA": "AddFriendSheet.module__requestsList___cUhkT3",
  "Jt": "AddFriendSheet.module__requestDivider___cUhkT3",
};

module.exports = exports;
